/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 847);
/******/ })
/************************************************************************/
/******/ ({

/***/ 15:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 847:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(848);


/***/ }),

/***/ 848:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// This file needs to be added as an entry for webpack.prod so runtime env vars are injected. http://bit.ly/2vmb3Hk
var runtimeEnv=__webpack_require__(849);global.pbgEnv=runtimeEnv();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),

/***/ 849:
/***/ (function(module, exports, __webpack_require__) {

// Capture environment as module variable to allow testing.
var compileTimeEnv;
try {
  compileTimeEnv = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_AIRBRAKE_PROJECT_KEY":"3bd4e1747c7edc6bc5776e798d35d32b","REACT_APP_PRODUCTION_HOST":"","REACT_APP_CLOUDSPONGE_SNIPPET_URL":"https://api.cloudsponge.com/widget/y-pWay1w3W9QpS4YZsxbDQ.js","REACT_APP_PBG_API_ACCESS_KEY":"d264a170d490db6ef656f30716b640","REACT_APP_BUSINESS_URL":"https://groups-manage.keytravel.com/login","REACT_APP_EVENTS_API_HOST":"https://groups-api.keytravel.com/events","REACT_APP_FB_APP_ID":"2741740622712689","REACT_APP_HOTJAR_ID":"0","REACT_APP_AIRBRAKE_PROJECT_ID":"284049","REACT_APP_API_HOST":"https://groups-api.keytravel.com/consumer","REACT_APP_AIRBRAKE_ENV":"production","REACT_APP_SPREEDLY_KEY":"Oao6sZ9bAfqcJumfmTuSYlQvgKN"});
} catch(error) {
  compileTimeEnv = {};
  console.log(
    '`process.env` is not defined. '+
    'Compile-time environment will be empty.'
  );
}
// This template tag should be rendered/replaced with the environment in production.
// Padded to 4KB so that the data can be inserted without offsetting character 
// indexes of the bundle (avoids breaking source maps).
var runtimeEnv = '{{REACT_APP_VARS_AS_JSON______________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________}}';


// A function returning the runtime environment, so that 
// JSON parsing & errors occur at runtime instead of load time.
function loadRuntimeEnv() {
  var env;

  if (compileTimeEnv.NODE_ENV === 'production') {
    try {
      env = JSON.parse(runtimeEnv);
    } catch(error) {
      env = {};
      var overflowsMessage = runtimeEnv.slice(32,33) != null;
      console.error(
        'Runtime env vars cannot be parsed. '+
        'Content is `'+runtimeEnv.slice(0,31)+( overflowsMessage ? '…' : '' )+'`'
      );
    }

  } else {
    env = compileTimeEnv;
  }

  return env;
}

module.exports = loadRuntimeEnv;

/***/ })

/******/ });


// WEBPACK FOOTER //
// static/js/main.7b8e264c.js